// extracted by mini-css-extract-plugin
module.exports = {"Burger":"Rr26x7ZxI8fHM7qauZbC7"};